<template>
  <div class="flex">
    <figure :style="'background-image: url('+photo+')'"></figure>

    <hgroup>
      <h4>{{product.Name}}</h4>
      <cite>{{date}} {{time}}</cite>
      <cite>{{guests}} {{product.OverrideRateLabel ? guests == 1 ? product.RateLabelSingular : product.RateLabelPlural : guests == 1 ? "guest" : "guests"}}</cite>
    </hgroup>
  </div>
</template>

<script>
//import func from "../../vue-temp/vue-editor-bridge";
export default {
  name: "CartIconIndividual",
  props: ["product"],
  computed: {
    photo: function() {
      return (
        this.product.PhotoDomain +
        "w_140,h_140,c_fill" +
        "/v" +
        this.product.PhotoVersion +
        this.product.PhotoFolder +
        "/original"
      );
    },
    date: function() {
      //return this.product.Activities[0].AppointmentDate;
      return this.$moment(this.product.Activities[0].AppointmentDate).format(
        "ddd, MMM D"
      );
    },
    time: function() {
      return this.product.Activities.length &&
        this.product.Activities[0].SelectedTimes.length
        ? this.product.Activities[0].SelectedTimes[0].DisplayName
        : "";
    },

    guests() {
      return this.product.Participants;
    }
  }
};
</script>

<style>
</style>